import React, { Fragment } from 'react'
import { Link, useLocation } from 'react-router-dom'
import logo from '../../assets/icons/logo.svg'
import MobileSidebar from '../MobileSidebar/MobileSidebar'
import * as Styles from './header'
import { useSelector } from 'react-redux'


function Header() {
    const { pathname } = useLocation() 
    const { isLoggedIn } = useSelector(state => state.auth)


    return (
        <Fragment>
            <Styles.Root>
                <div className="container">
                    <div className="left">
                        <a href="https://mintengine.org">
                            <img src={logo} alt="" />
                            <span>Mint Engine</span>
                        </a>
                    </div>
                    <div className={ `right ${pathname === '/' ? 'hideRight' : ''}` }>
                        {
                            !isLoggedIn && (
                                <Link to={ pathname === '/signup' ? '/login' : '/signup' }>
                                    { pathname === '/signup' ? 'LOGIN' : 'SIGN UP' }
                                </Link>
                            )
                        }
                        <MobileSidebar />   
                    </div>
                </div>
            </Styles.Root>
        </Fragment>
    )
}

export default Header
